// import { useFirebaseAuth } from '@smart-maps/firebase';
// import firebase from 'firebase/app';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
// import { useDispatch } from 'react-redux';

// import { deleteUser } from '../../../redux/actions';

const useStyles = createUseStyles({
  delete: {
    '&:hover': {
      background: 'rgba(0, 0, 0, 1)',
      color: '#C94130',
    },
    background: 'rgba(0, 0, 0, 0.1)',
    borderRadius: 4,
    color: '#919191',
    composes: ['is-block', 'is-bold', 'py12', 'mt12', 'fs12'],
    transition: 'background 0.3s, color 0.3s',
  },
});

const DeleteAccountButtonComponent = React.memo(() => {
  const classes = useStyles();
  // const dispatch = useDispatch();
  // const { user: credentials } = useFirebaseAuth();

  const deleteHandler = useCallback(() => {
    // const user = firebase.auth().currentUser;
    // user
    //   .reauthenticateWithCredential(credentials)
    //   .then(() => user.delete())
    //   .then(() => dispatch(deleteUser(user.uid)))
    //   .catch(() => {});
  }, []);

  return (
    <button className={classes.delete} type="button" onClick={deleteHandler}>
      <span>Supprimer mon compte</span>
    </button>
  );
});

DeleteAccountButtonComponent.displayName = 'DeleteAccountButtonComponent';

export default DeleteAccountButtonComponent;
